// Utils
import { getDeleteTasksSuggestionDismissed } from '../../taskListSelector';

export const shouldShowDeleteTasksSuggestion = (element) => {
    // If already dismissed then don't suggest again
    if (getDeleteTasksSuggestionDismissed(element)) return false;

    return true;
};
